/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  WebApiCompanyDtoCompanyPublicSiteDto,
  WebApiCustomListsDtoCreateCustomListItemDto,
  WebApiCustomListsDtoCustomListItemDto,
  WebApiCustomListsDtoUpdateCustomListItemDto,
  WebApiMemberDtoAddMemberFromPublicSiteDto,
  WebApiMemberDtoCreatePasswordCodeDto,
  WebApiMemberDtoGetMemberResultDto,
  WebApiModelsCustomListField,
  WebApiModelsMemberField,
  WebApiModelsMembershipProduct,
  WebApiPublicSiteDtoAddOwnFamilyMemberDto,
  WebApiPublicSiteDtoEditableCustomListDto,
  WebApiPublicSiteDtoFamilyMemberOwnedDto,
  WebApiPublicSiteDtoGetFamilyMemberSelfResultDto,
  WebApiPublicSiteDtoLoginWithPasswordCodeDto,
  WebApiPublicSiteDtoPublicMemberPaymentsDto,
  WebApiPublicSiteDtoPublicMemberViewResultDto,
  WebApiPublicSiteDtoPublicSessionDto,
  WebApiPublicSiteDtoUpdateFamilyMemberSelfDto,
  WebApiPublicSiteDtoUpdateOwnFamilyMemberDto,
  WebApiServicesDataTransferObjectsGroupServiceActiveUserByPasswordCode,
  WebApiServicesDataTransferObjectsGroupServiceConfirmMemberEmailChangeDto,
  WebApiServicesDataTransferObjectsGroupServiceUpdateMemberResultDto,
  WebApiServicesDataTransferObjectsGroupServiceUpdatePublicMemberDto,
  WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto,
  WebApiServicesDataTransferObjectsReplyServiceMemberEventDto,
  WebApiServicesDataTransferObjectsReplyServiceMemberReplyDto,
  WebApiServicesDataTransferObjectsReplyServiceSaveMemberReplyDto,
} from '../models';
import {
    WebApiCompanyDtoCompanyPublicSiteDtoFromJSON,
    WebApiCompanyDtoCompanyPublicSiteDtoToJSON,
    WebApiCustomListsDtoCreateCustomListItemDtoFromJSON,
    WebApiCustomListsDtoCreateCustomListItemDtoToJSON,
    WebApiCustomListsDtoCustomListItemDtoFromJSON,
    WebApiCustomListsDtoCustomListItemDtoToJSON,
    WebApiCustomListsDtoUpdateCustomListItemDtoFromJSON,
    WebApiCustomListsDtoUpdateCustomListItemDtoToJSON,
    WebApiMemberDtoAddMemberFromPublicSiteDtoFromJSON,
    WebApiMemberDtoAddMemberFromPublicSiteDtoToJSON,
    WebApiMemberDtoCreatePasswordCodeDtoFromJSON,
    WebApiMemberDtoCreatePasswordCodeDtoToJSON,
    WebApiMemberDtoGetMemberResultDtoFromJSON,
    WebApiMemberDtoGetMemberResultDtoToJSON,
    WebApiModelsCustomListFieldFromJSON,
    WebApiModelsCustomListFieldToJSON,
    WebApiModelsMemberFieldFromJSON,
    WebApiModelsMemberFieldToJSON,
    WebApiModelsMembershipProductFromJSON,
    WebApiModelsMembershipProductToJSON,
    WebApiPublicSiteDtoAddOwnFamilyMemberDtoFromJSON,
    WebApiPublicSiteDtoAddOwnFamilyMemberDtoToJSON,
    WebApiPublicSiteDtoEditableCustomListDtoFromJSON,
    WebApiPublicSiteDtoEditableCustomListDtoToJSON,
    WebApiPublicSiteDtoFamilyMemberOwnedDtoFromJSON,
    WebApiPublicSiteDtoFamilyMemberOwnedDtoToJSON,
    WebApiPublicSiteDtoGetFamilyMemberSelfResultDtoFromJSON,
    WebApiPublicSiteDtoGetFamilyMemberSelfResultDtoToJSON,
    WebApiPublicSiteDtoLoginWithPasswordCodeDtoFromJSON,
    WebApiPublicSiteDtoLoginWithPasswordCodeDtoToJSON,
    WebApiPublicSiteDtoPublicMemberPaymentsDtoFromJSON,
    WebApiPublicSiteDtoPublicMemberPaymentsDtoToJSON,
    WebApiPublicSiteDtoPublicMemberViewResultDtoFromJSON,
    WebApiPublicSiteDtoPublicMemberViewResultDtoToJSON,
    WebApiPublicSiteDtoPublicSessionDtoFromJSON,
    WebApiPublicSiteDtoPublicSessionDtoToJSON,
    WebApiPublicSiteDtoUpdateFamilyMemberSelfDtoFromJSON,
    WebApiPublicSiteDtoUpdateFamilyMemberSelfDtoToJSON,
    WebApiPublicSiteDtoUpdateOwnFamilyMemberDtoFromJSON,
    WebApiPublicSiteDtoUpdateOwnFamilyMemberDtoToJSON,
    WebApiServicesDataTransferObjectsGroupServiceActiveUserByPasswordCodeFromJSON,
    WebApiServicesDataTransferObjectsGroupServiceActiveUserByPasswordCodeToJSON,
    WebApiServicesDataTransferObjectsGroupServiceConfirmMemberEmailChangeDtoFromJSON,
    WebApiServicesDataTransferObjectsGroupServiceConfirmMemberEmailChangeDtoToJSON,
    WebApiServicesDataTransferObjectsGroupServiceUpdateMemberResultDtoFromJSON,
    WebApiServicesDataTransferObjectsGroupServiceUpdateMemberResultDtoToJSON,
    WebApiServicesDataTransferObjectsGroupServiceUpdatePublicMemberDtoFromJSON,
    WebApiServicesDataTransferObjectsGroupServiceUpdatePublicMemberDtoToJSON,
    WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDtoFromJSON,
    WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDtoToJSON,
    WebApiServicesDataTransferObjectsReplyServiceMemberEventDtoFromJSON,
    WebApiServicesDataTransferObjectsReplyServiceMemberEventDtoToJSON,
    WebApiServicesDataTransferObjectsReplyServiceMemberReplyDtoFromJSON,
    WebApiServicesDataTransferObjectsReplyServiceMemberReplyDtoToJSON,
    WebApiServicesDataTransferObjectsReplyServiceSaveMemberReplyDtoFromJSON,
    WebApiServicesDataTransferObjectsReplyServiceSaveMemberReplyDtoToJSON,
} from '../models';

export interface ApiPublicSiteActivateAccountFromPublicSitePostRequest {
    webApiServicesDataTransferObjectsGroupServiceActiveUserByPasswordCode?: WebApiServicesDataTransferObjectsGroupServiceActiveUserByPasswordCode;
}

export interface ApiPublicSiteAddMemberFromPublicSitePostRequest {
    webApiMemberDtoAddMemberFromPublicSiteDto?: WebApiMemberDtoAddMemberFromPublicSiteDto;
}

export interface ApiPublicSiteAddMyFamilyMemberPostRequest {
    webApiPublicSiteDtoAddOwnFamilyMemberDto?: WebApiPublicSiteDtoAddOwnFamilyMemberDto;
}

export interface ApiPublicSiteConfirmEmailChangePostRequest {
    webApiServicesDataTransferObjectsGroupServiceConfirmMemberEmailChangeDto?: WebApiServicesDataTransferObjectsGroupServiceConfirmMemberEmailChangeDto;
}

export interface ApiPublicSiteCreatePasswordCodePostRequest {
    webApiMemberDtoCreatePasswordCodeDto?: WebApiMemberDtoCreatePasswordCodeDto;
}

export interface ApiPublicSiteCustomListItemsCustomListIdGetRequest {
    customListId: number;
}

export interface ApiPublicSiteCustomListItemsCustomListIdIdDeleteRequest {
    customListId: number;
    id: number;
}

export interface ApiPublicSiteCustomListItemsCustomListIdIdPostRequest {
    customListId: number;
    id: number;
    webApiCustomListsDtoUpdateCustomListItemDto?: WebApiCustomListsDtoUpdateCustomListItemDto;
}

export interface ApiPublicSiteCustomListItemsCustomListIdLookupGetRequest {
    customListId: number;
}

export interface ApiPublicSiteCustomListItemsCustomListIdPostRequest {
    customListId: number;
    webApiCustomListsDtoCreateCustomListItemDto?: WebApiCustomListsDtoCreateCustomListItemDto;
}

export interface ApiPublicSiteDeleteMyFamilyMemberPostRequest {
    memberId?: number;
}

export interface ApiPublicSiteEditableCustomListsCustomListIdFieldsGetRequest {
    customListId: number;
}

export interface ApiPublicSiteGetCompanyPublicSiteByUrlGetRequest {
    url?: string;
}

export interface ApiPublicSiteGetEventReplyGetRequest {
    eventUniqueId?: string;
}

export interface ApiPublicSiteGetMemberFieldsPublicSiteByUrlGetRequest {
    url?: string;
}

export interface ApiPublicSiteGetMemberPaymentReceiptGetRequest {
    year?: number;
}

export interface ApiPublicSiteGetMembershipProductsFromPublicSiteByUrlGetRequest {
    url?: string;
}

export interface ApiPublicSiteGetPublicMemberViewGetRequest {
    url?: string;
}

export interface ApiPublicSiteHasPublicMemberViewGetRequest {
    url?: string;
}

export interface ApiPublicSiteLoginWithPasswordCodePostRequest {
    webApiPublicSiteDtoLoginWithPasswordCodeDto?: WebApiPublicSiteDtoLoginWithPasswordCodeDto;
}

export interface ApiPublicSiteSaveEventReplyPostRequest {
    webApiServicesDataTransferObjectsReplyServiceSaveMemberReplyDto?: WebApiServicesDataTransferObjectsReplyServiceSaveMemberReplyDto;
}

export interface ApiPublicSiteUpdateFamilyMemberSelfPostRequest {
    webApiPublicSiteDtoUpdateFamilyMemberSelfDto?: WebApiPublicSiteDtoUpdateFamilyMemberSelfDto;
}

export interface ApiPublicSiteUpdateMemberPostRequest {
    webApiServicesDataTransferObjectsGroupServiceUpdatePublicMemberDto?: WebApiServicesDataTransferObjectsGroupServiceUpdatePublicMemberDto;
}

export interface ApiPublicSiteUpdateMyFamilyMemberPostRequest {
    webApiPublicSiteDtoUpdateOwnFamilyMemberDto?: WebApiPublicSiteDtoUpdateOwnFamilyMemberDto;
}

/**
 * 
 */
export class PublicSiteApi extends runtime.BaseAPI {

    /**
     * 
     */
    async apiPublicSiteActivateAccountFromPublicSitePostRaw(requestParameters: ApiPublicSiteActivateAccountFromPublicSitePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/PublicSite/ActivateAccountFromPublicSite`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiServicesDataTransferObjectsGroupServiceActiveUserByPasswordCodeToJSON(requestParameters.webApiServicesDataTransferObjectsGroupServiceActiveUserByPasswordCode),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * 
     */
    async apiPublicSiteActivateAccountFromPublicSitePost(requestParameters: ApiPublicSiteActivateAccountFromPublicSitePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.apiPublicSiteActivateAccountFromPublicSitePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async apiPublicSiteAddMemberFromPublicSitePostRaw(requestParameters: ApiPublicSiteAddMemberFromPublicSitePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/PublicSite/AddMemberFromPublicSite`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiMemberDtoAddMemberFromPublicSiteDtoToJSON(requestParameters.webApiMemberDtoAddMemberFromPublicSiteDto),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * 
     */
    async apiPublicSiteAddMemberFromPublicSitePost(requestParameters: ApiPublicSiteAddMemberFromPublicSitePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.apiPublicSiteAddMemberFromPublicSitePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add a new family member to the authenticated primary member\'s household.
     */
    async apiPublicSiteAddMyFamilyMemberPostRaw(requestParameters: ApiPublicSiteAddMyFamilyMemberPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/PublicSite/AddMyFamilyMember`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiPublicSiteDtoAddOwnFamilyMemberDtoToJSON(requestParameters.webApiPublicSiteDtoAddOwnFamilyMemberDto),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Add a new family member to the authenticated primary member\'s household.
     */
    async apiPublicSiteAddMyFamilyMemberPost(requestParameters: ApiPublicSiteAddMyFamilyMemberPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.apiPublicSiteAddMyFamilyMemberPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Confirms a member\'s pending email change via the link sent to the new address.
     */
    async apiPublicSiteConfirmEmailChangePostRaw(requestParameters: ApiPublicSiteConfirmEmailChangePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/PublicSite/ConfirmEmailChange`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiServicesDataTransferObjectsGroupServiceConfirmMemberEmailChangeDtoToJSON(requestParameters.webApiServicesDataTransferObjectsGroupServiceConfirmMemberEmailChangeDto),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Confirms a member\'s pending email change via the link sent to the new address.
     */
    async apiPublicSiteConfirmEmailChangePost(requestParameters: ApiPublicSiteConfirmEmailChangePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.apiPublicSiteConfirmEmailChangePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async apiPublicSiteCreatePasswordCodePostRaw(requestParameters: ApiPublicSiteCreatePasswordCodePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/PublicSite/CreatePasswordCode`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiMemberDtoCreatePasswordCodeDtoToJSON(requestParameters.webApiMemberDtoCreatePasswordCodeDto),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async apiPublicSiteCreatePasswordCodePost(requestParameters: ApiPublicSiteCreatePasswordCodePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiPublicSiteCreatePasswordCodePostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiPublicSiteCustomListItemsCustomListIdGetRaw(requestParameters: ApiPublicSiteCustomListItemsCustomListIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WebApiCustomListsDtoCustomListItemDto>>> {
        if (requestParameters.customListId === null || requestParameters.customListId === undefined) {
            throw new runtime.RequiredError('customListId','Required parameter requestParameters.customListId was null or undefined when calling apiPublicSiteCustomListItemsCustomListIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/PublicSite/custom-list-items/{customListId}`.replace(`{${"customListId"}}`, encodeURIComponent(String(requestParameters.customListId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WebApiCustomListsDtoCustomListItemDtoFromJSON));
    }

    /**
     */
    async apiPublicSiteCustomListItemsCustomListIdGet(requestParameters: ApiPublicSiteCustomListItemsCustomListIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WebApiCustomListsDtoCustomListItemDto>> {
        const response = await this.apiPublicSiteCustomListItemsCustomListIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiPublicSiteCustomListItemsCustomListIdIdDeleteRaw(requestParameters: ApiPublicSiteCustomListItemsCustomListIdIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.customListId === null || requestParameters.customListId === undefined) {
            throw new runtime.RequiredError('customListId','Required parameter requestParameters.customListId was null or undefined when calling apiPublicSiteCustomListItemsCustomListIdIdDelete.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiPublicSiteCustomListItemsCustomListIdIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/PublicSite/custom-list-items/{customListId}/{id}`.replace(`{${"customListId"}}`, encodeURIComponent(String(requestParameters.customListId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiPublicSiteCustomListItemsCustomListIdIdDelete(requestParameters: ApiPublicSiteCustomListItemsCustomListIdIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiPublicSiteCustomListItemsCustomListIdIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiPublicSiteCustomListItemsCustomListIdIdPostRaw(requestParameters: ApiPublicSiteCustomListItemsCustomListIdIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiCustomListsDtoCustomListItemDto>> {
        if (requestParameters.customListId === null || requestParameters.customListId === undefined) {
            throw new runtime.RequiredError('customListId','Required parameter requestParameters.customListId was null or undefined when calling apiPublicSiteCustomListItemsCustomListIdIdPost.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiPublicSiteCustomListItemsCustomListIdIdPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/PublicSite/custom-list-items/{customListId}/{id}`.replace(`{${"customListId"}}`, encodeURIComponent(String(requestParameters.customListId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiCustomListsDtoUpdateCustomListItemDtoToJSON(requestParameters.webApiCustomListsDtoUpdateCustomListItemDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiCustomListsDtoCustomListItemDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiPublicSiteCustomListItemsCustomListIdIdPost(requestParameters: ApiPublicSiteCustomListItemsCustomListIdIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiCustomListsDtoCustomListItemDto> {
        const response = await this.apiPublicSiteCustomListItemsCustomListIdIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * All items in a company\'s custom list, regardless of owner - used to populate lookup/dropdown  options when a form field references another list (see GetMyCustomListItemsAsync for the  member-owned-only variant). Only permitted when the target list is itself flagged as  member-visible (MembersEditRights.OwnItems) - members can\'t read lists that aren\'t.
     */
    async apiPublicSiteCustomListItemsCustomListIdLookupGetRaw(requestParameters: ApiPublicSiteCustomListItemsCustomListIdLookupGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WebApiCustomListsDtoCustomListItemDto>>> {
        if (requestParameters.customListId === null || requestParameters.customListId === undefined) {
            throw new runtime.RequiredError('customListId','Required parameter requestParameters.customListId was null or undefined when calling apiPublicSiteCustomListItemsCustomListIdLookupGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/PublicSite/custom-list-items/{customListId}/lookup`.replace(`{${"customListId"}}`, encodeURIComponent(String(requestParameters.customListId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WebApiCustomListsDtoCustomListItemDtoFromJSON));
    }

    /**
     * All items in a company\'s custom list, regardless of owner - used to populate lookup/dropdown  options when a form field references another list (see GetMyCustomListItemsAsync for the  member-owned-only variant). Only permitted when the target list is itself flagged as  member-visible (MembersEditRights.OwnItems) - members can\'t read lists that aren\'t.
     */
    async apiPublicSiteCustomListItemsCustomListIdLookupGet(requestParameters: ApiPublicSiteCustomListItemsCustomListIdLookupGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WebApiCustomListsDtoCustomListItemDto>> {
        const response = await this.apiPublicSiteCustomListItemsCustomListIdLookupGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiPublicSiteCustomListItemsCustomListIdPostRaw(requestParameters: ApiPublicSiteCustomListItemsCustomListIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiCustomListsDtoCustomListItemDto>> {
        if (requestParameters.customListId === null || requestParameters.customListId === undefined) {
            throw new runtime.RequiredError('customListId','Required parameter requestParameters.customListId was null or undefined when calling apiPublicSiteCustomListItemsCustomListIdPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/PublicSite/custom-list-items/{customListId}`.replace(`{${"customListId"}}`, encodeURIComponent(String(requestParameters.customListId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiCustomListsDtoCreateCustomListItemDtoToJSON(requestParameters.webApiCustomListsDtoCreateCustomListItemDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiCustomListsDtoCustomListItemDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiPublicSiteCustomListItemsCustomListIdPost(requestParameters: ApiPublicSiteCustomListItemsCustomListIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiCustomListsDtoCustomListItemDto> {
        const response = await this.apiPublicSiteCustomListItemsCustomListIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete one of the authenticated primary member\'s own family members.
     */
    async apiPublicSiteDeleteMyFamilyMemberPostRaw(requestParameters: ApiPublicSiteDeleteMyFamilyMemberPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        if (requestParameters.memberId !== undefined) {
            queryParameters['memberId'] = requestParameters.memberId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/PublicSite/DeleteMyFamilyMember`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Delete one of the authenticated primary member\'s own family members.
     */
    async apiPublicSiteDeleteMyFamilyMemberPost(requestParameters: ApiPublicSiteDeleteMyFamilyMemberPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.apiPublicSiteDeleteMyFamilyMemberPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiPublicSiteEditableCustomListsCustomListIdFieldsGetRaw(requestParameters: ApiPublicSiteEditableCustomListsCustomListIdFieldsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WebApiModelsCustomListField>>> {
        if (requestParameters.customListId === null || requestParameters.customListId === undefined) {
            throw new runtime.RequiredError('customListId','Required parameter requestParameters.customListId was null or undefined when calling apiPublicSiteEditableCustomListsCustomListIdFieldsGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/PublicSite/editable-custom-lists/{customListId}/fields`.replace(`{${"customListId"}}`, encodeURIComponent(String(requestParameters.customListId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WebApiModelsCustomListFieldFromJSON));
    }

    /**
     */
    async apiPublicSiteEditableCustomListsCustomListIdFieldsGet(requestParameters: ApiPublicSiteEditableCustomListsCustomListIdFieldsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WebApiModelsCustomListField>> {
        const response = await this.apiPublicSiteEditableCustomListsCustomListIdFieldsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiPublicSiteEditableCustomListsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WebApiPublicSiteDtoEditableCustomListDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/PublicSite/editable-custom-lists`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WebApiPublicSiteDtoEditableCustomListDtoFromJSON));
    }

    /**
     */
    async apiPublicSiteEditableCustomListsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WebApiPublicSiteDtoEditableCustomListDto>> {
        const response = await this.apiPublicSiteEditableCustomListsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get company public site by url
     */
    async apiPublicSiteGetCompanyPublicSiteByUrlGetRaw(requestParameters: ApiPublicSiteGetCompanyPublicSiteByUrlGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiCompanyDtoCompanyPublicSiteDto>> {
        const queryParameters: any = {};

        if (requestParameters.url !== undefined) {
            queryParameters['url'] = requestParameters.url;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/PublicSite/GetCompanyPublicSiteByUrl`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiCompanyDtoCompanyPublicSiteDtoFromJSON(jsonValue));
    }

    /**
     * Get company public site by url
     */
    async apiPublicSiteGetCompanyPublicSiteByUrlGet(requestParameters: ApiPublicSiteGetCompanyPublicSiteByUrlGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiCompanyDtoCompanyPublicSiteDto> {
        const response = await this.apiPublicSiteGetCompanyPublicSiteByUrlGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Who the logged in member is and the reply the member already has for an event of the member\'s company.
     */
    async apiPublicSiteGetEventReplyGetRaw(requestParameters: ApiPublicSiteGetEventReplyGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiServicesDataTransferObjectsReplyServiceMemberReplyDto>> {
        const queryParameters: any = {};

        if (requestParameters.eventUniqueId !== undefined) {
            queryParameters['eventUniqueId'] = requestParameters.eventUniqueId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/PublicSite/GetEventReply`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiServicesDataTransferObjectsReplyServiceMemberReplyDtoFromJSON(jsonValue));
    }

    /**
     * Who the logged in member is and the reply the member already has for an event of the member\'s company.
     */
    async apiPublicSiteGetEventReplyGet(requestParameters: ApiPublicSiteGetEventReplyGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiServicesDataTransferObjectsReplyServiceMemberReplyDto> {
        const response = await this.apiPublicSiteGetEventReplyGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the authenticated family member\'s own (reduced) field set.
     */
    async apiPublicSiteGetFamilyMemberSelfGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiPublicSiteDtoGetFamilyMemberSelfResultDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/PublicSite/GetFamilyMemberSelf`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiPublicSiteDtoGetFamilyMemberSelfResultDtoFromJSON(jsonValue));
    }

    /**
     * Get the authenticated family member\'s own (reduced) field set.
     */
    async apiPublicSiteGetFamilyMemberSelfGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiPublicSiteDtoGetFamilyMemberSelfResultDto> {
        const response = await this.apiPublicSiteGetFamilyMemberSelfGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get the logged-in member\'s membership payment status per year (and pay links when enabled).  Family members see their household primary\'s status.
     */
    async apiPublicSiteGetMemberEventsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WebApiServicesDataTransferObjectsReplyServiceMemberEventDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/PublicSite/GetMemberEvents`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WebApiServicesDataTransferObjectsReplyServiceMemberEventDtoFromJSON));
    }

    /**
     * Get the logged-in member\'s membership payment status per year (and pay links when enabled).  Family members see their household primary\'s status.
     */
    async apiPublicSiteGetMemberEventsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WebApiServicesDataTransferObjectsReplyServiceMemberEventDto>> {
        const response = await this.apiPublicSiteGetMemberEventsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async apiPublicSiteGetMemberFieldsPublicSiteByUrlGetRaw(requestParameters: ApiPublicSiteGetMemberFieldsPublicSiteByUrlGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WebApiModelsMemberField>>> {
        const queryParameters: any = {};

        if (requestParameters.url !== undefined) {
            queryParameters['url'] = requestParameters.url;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/PublicSite/GetMemberFieldsPublicSiteByUrl`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WebApiModelsMemberFieldFromJSON));
    }

    /**
     * 
     */
    async apiPublicSiteGetMemberFieldsPublicSiteByUrlGet(requestParameters: ApiPublicSiteGetMemberFieldsPublicSiteByUrlGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WebApiModelsMemberField>> {
        const response = await this.apiPublicSiteGetMemberFieldsPublicSiteByUrlGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the authenticated member\'s data
     */
    async apiPublicSiteGetMemberGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiMemberDtoGetMemberResultDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/PublicSite/GetMember`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiMemberDtoGetMemberResultDtoFromJSON(jsonValue));
    }

    /**
     * Get the authenticated member\'s data
     */
    async apiPublicSiteGetMemberGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiMemberDtoGetMemberResultDto> {
        const response = await this.apiPublicSiteGetMemberGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * The receipt (PDF) of the Ping Payments link the logged-in member paid the year with.
     */
    async apiPublicSiteGetMemberPaymentReceiptGetRaw(requestParameters: ApiPublicSiteGetMemberPaymentReceiptGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.year !== undefined) {
            queryParameters['year'] = requestParameters.year;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/PublicSite/GetMemberPaymentReceipt`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * The receipt (PDF) of the Ping Payments link the logged-in member paid the year with.
     */
    async apiPublicSiteGetMemberPaymentReceiptGet(requestParameters: ApiPublicSiteGetMemberPaymentReceiptGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiPublicSiteGetMemberPaymentReceiptGetRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiPublicSiteGetMemberPaymentsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiPublicSiteDtoPublicMemberPaymentsDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/PublicSite/GetMemberPayments`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiPublicSiteDtoPublicMemberPaymentsDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiPublicSiteGetMemberPaymentsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiPublicSiteDtoPublicMemberPaymentsDto> {
        const response = await this.apiPublicSiteGetMemberPaymentsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async apiPublicSiteGetMembershipProductsFromPublicSiteByUrlGetRaw(requestParameters: ApiPublicSiteGetMembershipProductsFromPublicSiteByUrlGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WebApiModelsMembershipProduct>>> {
        const queryParameters: any = {};

        if (requestParameters.url !== undefined) {
            queryParameters['url'] = requestParameters.url;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/PublicSite/GetMembershipProductsFromPublicSiteByUrl`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WebApiModelsMembershipProductFromJSON));
    }

    /**
     * 
     */
    async apiPublicSiteGetMembershipProductsFromPublicSiteByUrlGet(requestParameters: ApiPublicSiteGetMembershipProductsFromPublicSiteByUrlGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WebApiModelsMembershipProduct>> {
        const response = await this.apiPublicSiteGetMembershipProductsFromPublicSiteByUrlGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List the authenticated primary member\'s own family members.
     */
    async apiPublicSiteGetMyFamilyMembersGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WebApiPublicSiteDtoFamilyMemberOwnedDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/PublicSite/GetMyFamilyMembers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WebApiPublicSiteDtoFamilyMemberOwnedDtoFromJSON));
    }

    /**
     * List the authenticated primary member\'s own family members.
     */
    async apiPublicSiteGetMyFamilyMembersGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WebApiPublicSiteDtoFamilyMemberOwnedDto>> {
        const response = await this.apiPublicSiteGetMyFamilyMembersGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get the public member view columns and active members for the company
     */
    async apiPublicSiteGetPublicMemberViewGetRaw(requestParameters: ApiPublicSiteGetPublicMemberViewGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiPublicSiteDtoPublicMemberViewResultDto>> {
        const queryParameters: any = {};

        if (requestParameters.url !== undefined) {
            queryParameters['url'] = requestParameters.url;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/PublicSite/GetPublicMemberView`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiPublicSiteDtoPublicMemberViewResultDtoFromJSON(jsonValue));
    }

    /**
     * Get the public member view columns and active members for the company
     */
    async apiPublicSiteGetPublicMemberViewGet(requestParameters: ApiPublicSiteGetPublicMemberViewGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiPublicSiteDtoPublicMemberViewResultDto> {
        const response = await this.apiPublicSiteGetPublicMemberViewGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Tells the SPA which self-edit page to render for the logged-in member (regular vs. family).
     */
    async apiPublicSiteGetSessionGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiPublicSiteDtoPublicSessionDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/PublicSite/GetSession`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiPublicSiteDtoPublicSessionDtoFromJSON(jsonValue));
    }

    /**
     * Tells the SPA which self-edit page to render for the logged-in member (regular vs. family).
     */
    async apiPublicSiteGetSessionGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiPublicSiteDtoPublicSessionDto> {
        const response = await this.apiPublicSiteGetSessionGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Check if a public member view exists for the company
     */
    async apiPublicSiteHasPublicMemberViewGetRaw(requestParameters: ApiPublicSiteHasPublicMemberViewGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        if (requestParameters.url !== undefined) {
            queryParameters['url'] = requestParameters.url;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/PublicSite/HasPublicMemberView`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Check if a public member view exists for the company
     */
    async apiPublicSiteHasPublicMemberViewGet(requestParameters: ApiPublicSiteHasPublicMemberViewGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.apiPublicSiteHasPublicMemberViewGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Login with a password code and set auth cookie
     */
    async apiPublicSiteLoginWithPasswordCodePostRaw(requestParameters: ApiPublicSiteLoginWithPasswordCodePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/PublicSite/LoginWithPasswordCode`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiPublicSiteDtoLoginWithPasswordCodeDtoToJSON(requestParameters.webApiPublicSiteDtoLoginWithPasswordCodeDto),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Login with a password code and set auth cookie
     */
    async apiPublicSiteLoginWithPasswordCodePost(requestParameters: ApiPublicSiteLoginWithPasswordCodePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiPublicSiteLoginWithPasswordCodePostRaw(requestParameters, initOverrides);
    }

    /**
     * Logout the authenticated member and clear auth cookie
     */
    async apiPublicSiteLogoutPostRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/PublicSite/Logout`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Logout the authenticated member and clear auth cookie
     */
    async apiPublicSiteLogoutPost(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiPublicSiteLogoutPostRaw(initOverrides);
    }

    /**
     * Creates or changes the logged in member\'s reply for an event of the member\'s company.
     */
    async apiPublicSiteSaveEventReplyPostRaw(requestParameters: ApiPublicSiteSaveEventReplyPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/PublicSite/SaveEventReply`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiServicesDataTransferObjectsReplyServiceSaveMemberReplyDtoToJSON(requestParameters.webApiServicesDataTransferObjectsReplyServiceSaveMemberReplyDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDtoFromJSON(jsonValue));
    }

    /**
     * Creates or changes the logged in member\'s reply for an event of the member\'s company.
     */
    async apiPublicSiteSaveEventReplyPost(requestParameters: ApiPublicSiteSaveEventReplyPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto> {
        const response = await this.apiPublicSiteSaveEventReplyPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the authenticated family member\'s own (reduced) field set.
     */
    async apiPublicSiteUpdateFamilyMemberSelfPostRaw(requestParameters: ApiPublicSiteUpdateFamilyMemberSelfPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiServicesDataTransferObjectsGroupServiceUpdateMemberResultDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/PublicSite/UpdateFamilyMemberSelf`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiPublicSiteDtoUpdateFamilyMemberSelfDtoToJSON(requestParameters.webApiPublicSiteDtoUpdateFamilyMemberSelfDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiServicesDataTransferObjectsGroupServiceUpdateMemberResultDtoFromJSON(jsonValue));
    }

    /**
     * Update the authenticated family member\'s own (reduced) field set.
     */
    async apiPublicSiteUpdateFamilyMemberSelfPost(requestParameters: ApiPublicSiteUpdateFamilyMemberSelfPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiServicesDataTransferObjectsGroupServiceUpdateMemberResultDto> {
        const response = await this.apiPublicSiteUpdateFamilyMemberSelfPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the authenticated member\'s data
     */
    async apiPublicSiteUpdateMemberPostRaw(requestParameters: ApiPublicSiteUpdateMemberPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiServicesDataTransferObjectsGroupServiceUpdateMemberResultDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/PublicSite/UpdateMember`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiServicesDataTransferObjectsGroupServiceUpdatePublicMemberDtoToJSON(requestParameters.webApiServicesDataTransferObjectsGroupServiceUpdatePublicMemberDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiServicesDataTransferObjectsGroupServiceUpdateMemberResultDtoFromJSON(jsonValue));
    }

    /**
     * Update the authenticated member\'s data
     */
    async apiPublicSiteUpdateMemberPost(requestParameters: ApiPublicSiteUpdateMemberPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiServicesDataTransferObjectsGroupServiceUpdateMemberResultDto> {
        const response = await this.apiPublicSiteUpdateMemberPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update one of the authenticated primary member\'s own family members.
     */
    async apiPublicSiteUpdateMyFamilyMemberPostRaw(requestParameters: ApiPublicSiteUpdateMyFamilyMemberPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiServicesDataTransferObjectsGroupServiceUpdateMemberResultDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/PublicSite/UpdateMyFamilyMember`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiPublicSiteDtoUpdateOwnFamilyMemberDtoToJSON(requestParameters.webApiPublicSiteDtoUpdateOwnFamilyMemberDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiServicesDataTransferObjectsGroupServiceUpdateMemberResultDtoFromJSON(jsonValue));
    }

    /**
     * Update one of the authenticated primary member\'s own family members.
     */
    async apiPublicSiteUpdateMyFamilyMemberPost(requestParameters: ApiPublicSiteUpdateMyFamilyMemberPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiServicesDataTransferObjectsGroupServiceUpdateMemberResultDto> {
        const response = await this.apiPublicSiteUpdateMyFamilyMemberPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
